
import { useRef, useState } from 'react'
import Script from "next/script";


// <h1>hihiaaaas</h1>
// export const listContainer = ({ props }) => (
export const imageContainer = props => (
  <>
    <div className="container mx-auto builder-container">
      <div className="flex justify-center">
        <img className="max-h-[300px]" src={ ` ${props.builderState.context.builderContent.data.imageurl} ` }></img>
      </div>
    </div>
  </>
)